export const renderIcon = (icon, props = {}) => {
  const Icon = icon;
  return (
    <div {...props}>
      <Icon />
    </div>
  );
};
